import coin_icon from "@/assets/images/icon/coin-group.png";
import InteractivePanel from "@/components/interactive_panel";
import run_sound from "@/assets/audio/battleTick.mp3";
import win_sound from "@/assets/audio/battlewin.ogg";
import count_sound from "@/assets/audio/counting.mp3";
import move_sound from "@/assets/audio/moving.mp3";
import join_sound from "@/assets/audio/join.mp3";
import {
  conversion,
  countDownS,
  GetItemDuration,
  formatDate,
  imgfilter,
} from "@/tool";
import { CustomBlockTitle } from "@/partials/custom_block_title";
import Avatar from "@/components/avatar";
import battleOpen from "./battle_open.vue";
import Award from "@/components/award";
import battleCaseDetail from "../components/battleCaseDetail.vue";
import RewardModal from "@/components/RewardModal";

import QuickChatPoptip from "@/components/quick_chat_poptip/index.vue";

import main_chat_0 from "@/assets/audio/Man_Chat_0.mp3";
import main_chat_1 from "@/assets/audio/Man_Chat_1.mp3";
import main_chat_2 from "@/assets/audio/Man_Chat_2.mp3";
import main_chat_3 from "@/assets/audio/Man_Chat_3.mp3";

import main_emoji_0 from "@/assets/audio/emoj_xihongshi.ogg";
import main_emoji_1 from "@/assets/audio/emoj_chabei.ogg";

import message from "@/assets/audio/message.mp3";

import xihongshi_img from "@/assets/images/battle/xihongshi.png";
import chabei_img from "@/assets/images/battle/chabei.png";
import AnimateNumber from "@/components/AnimateNumber/index.vue";

import { mapState, mapMutations } from "vuex";
import { api_SellItem, api_CaseDetail } from "@/api";
// import { vueObj } from "@/main";

// const signalR = require("@microsoft/signalr");

export default {
  name: "RoomDetail",
  components: {
    "p-custom-block-title": CustomBlockTitle,
    "c-battle-open": battleOpen,
    "c-avatar": Avatar,
    "c-award": Award,
    "c-interactive-panel": InteractivePanel,
    "c-battleCaseDetail": battleCaseDetail,
    "c-RewardModal": RewardModal,
    "c-number": AnimateNumber,
    "c-quick-chat-poptip": QuickChatPoptip,
  },
  data() {
    return {
      animation_timer: null,
      emoji_text_list: [
        "大家好!很高兴见到各位",
        "和你合作真是太愉快了！",
        "快点吧,我等到花儿都谢了",
        "不要吵了！专心玩游戏吧！",
      ],
      roomDetail: {
        room: {
          memberid: 0,
          password: "",
          seatCount: 2,
          roomState: 0,
          winner_id: null,
          roomPrice: 0,
          cases: [],
          players: [],
          id: 0,
        },
        players: [],
      },
      quick_msg_list: [],
      roomChatScene: "CaseBattle",
      user_chat_list: [
        { show: false, text: "" },
        { show: false, text: "" },
        { show: false, text: "" },
        { show: false, text: "" },
      ],
      showWinDialog: false, // 对战结束后是否显示弹框
      curRoomState: 0,
      curRoundIndex: 0,
      curAcountingIndex: 0,
      curItemMaxPrice: 0,
      curItemMinPrice: 0,
      showProgress: false,
      isReplay: false,
      /** 音频列表 */
      sounds: [],
      quickMessageAudio: null,
      quickMessageAudioUnlocked: false,
      /** 加入房间 模态框 */
      join_room_modal: {
        flag: false,
        password: "",
        hasPassword: false,
        roomid: 0,
        price: 0,
        seatIndex: 0
      },
      showQuickMatchDialog: false, // 匹配AI弹窗
      aiSearchQuery: '', // 新增：搜索过滤关键词
      curSelectedSeatIndex: null,  // 当前选中的座位索引
      selectedAiId: null,          // 当前选中的指定AI ID
      availableAiList: [           // 预设可用AI列表，实际开发中可以在 openAiMatchModal 时从接口或Hub拉取
        { id: 101, name: "AI 狂暴狙击手", avatar: "avatar/ai_1.png", description: "擅长快节奏开箱，幸运值极高", status: "online" },
        { id: 102, name: "AI 佛系收藏家", avatar: "avatar/ai_2.png", description: "追求稳健收益，策略型陪练", status: "online" },
        { id: 103, name: "AI 倒爷萌新", avatar: "avatar/ai_3.png", description: "随机玄学玄率，难以捉摸", status: "online" },
        { id: 104, name: "AI 全能战神", avatar: "avatar/ai_4.png", description: "高阶算法模拟，骨灰级玩家", status: "online" }
      ],
      /** 箱子详情 */
      case_detail_modal: {
        flag: false,
        caseInfo: {},
      },
      battle_detail_challenge_des_show: false,
      battle_challenge_des_btn_show: false,
      battleChallengeDetail: {
        isCurrentlyInChallenge: false, //当前是否正在连胜挑战
        winningSteakCount: 0, //连胜次数
        firstTickePrice: 0, //连胜第一次门票价格
        lastTicketPrice: 0, //最后一次连胜门票价格
        receivedGift: false, //是否已经领取奖励
        giftAmount: 0, //奖励金额
        cdkGiftRate: 0, //奖励等级： 1:0,3:1,5:3,8:10,12:20
        countDownSeconds: 0, //完成时间倒计时
        isChallengeEnable: false, //是否可以连胜挑战
        winningRoomId: 0, //连胜房间ID
      },
      isChallengeFailed: false,
      isChallengeFailedRoomId: 0,
      currentIsWinner: [], //当前赢家
      cdkGiftRateList: [], //奖励等级列表
    };
  },
  filters: {
    conversion,
    GetItemDuration,
  },
  computed: {
    ...mapState(["user", "isMute"]),
    seatList() {
      const total = this.roomDetail.room.seatCount;
      const list = new Array(total).fill(null);

      this.roomDetail.players.forEach(p => {
        if (p.seatIndex >= 0 && p.seatIndex < total) {
          list[p.seatIndex] = p;
        }
      });

      return list;
    },
    emptySeats() {
      const used = new Set(this.roomDetail.players.map(p => p.seatIndex));
      const empty = [];
      for (let i = 0; i < this.roomDetail.room.seatCount; i++) {
        if (!used.has(i)) empty.push(i);
      }
      return empty;
    },
    sortedPlayers() {
      if (!this.roomDetail || !this.roomDetail.players) return [];
      return [...this.roomDetail.players].sort((a, b) => a.seatIndex - b.seatIndex);
    },
    // 模糊匹配过滤后的 AI 列表
    filteredAiList() {
      if (!this.aiSearchQuery) {
        return this.availableAiList;
      }
      const query = this.aiSearchQuery.trim().toLowerCase();
      return this.availableAiList.filter(ai => {
        return ai.name.toLowerCase().includes(query);
      });
    },
    backIconWidthHeight() {
      return this.$screen.mobile ? "16px" : "21px";
    },
    curPageUrl() {
      return window.location.href;
    },
    curUserRealId() {
      return parseInt(this.user.id);
    },
    IsUserInRoom() {
      if (!this.roomDetail.room.id) return false;

      var myIndex = this.roomDetail.players.findIndex(
        (player) => player.memberid == this.curUserRealId
      );

      return myIndex > -1;
    },
    curRoundText() {
      return this.curRoundIndex >= this.roomDetail.room.cases.length
        ? this.roomDetail.room.cases.length
        : this.curRoundIndex + 1;
    },
    getCurUserRoundIsWin() {
      return function (memberid, round) {
        let returnResult = "",
          curPrizeList = [];
        curPrizeList = this.roomDetail.players.filter((res) => {
          let itemPrice = res.items[round - 1] || { price: 0 };

          if (this.roomDetail.room.isCrazyMode) {
            return itemPrice.price == this.curItemMinPrice;
          }

          return itemPrice.price == this.curItemMaxPrice;
        });
        if (curPrizeList.length == this.roomDetail.players.length) {
          returnResult = "tie";
        } else {
          var curUser = this.roomDetail.players.find(
            (_) => _.memberid == memberid
          );
          var curPrize = curUser.items[round - 1] || { price: 0 };

          if (this.roomDetail.room.isCrazyMode) {
            returnResult = curPrize.price <= this.curItemMinPrice ? "win" : "lose";
          } else {
            returnResult = curPrize.price >= this.curItemMaxPrice ? "win" : "lose";
          }

        }
        return returnResult;
      };
    },
    getCurUserProfit() {
      return function (memberid) {
        var prize = this.getCurUserPrize(memberid) || [];
        return prize.length > 0
          ? prize.map((_) => _.price).reduce((a, b) => a + b, 0)
          : 0;
      };
    },
    getCurCountUserProfit() {
      return function (memberid) {
        if (this.curRoomState == 3) return this.getCurUserProfit(memberid);

        var curUser = this.roomDetail.players.find(
          (_) => _.memberid == memberid
        );
        var prize = curUser.items.slice(0, this.curAcountingIndex) || [];
        return prize.length > 0
          ? prize.map((_) => _.price).reduce((a, b) => a + b, 0)
          : 0;
      };
    },
    getCurUserPrize() {
      return function (memberid) {
        var curUser = this.roomDetail.players.find(
          (_) => _.memberid == memberid
        );
        //console.log(curUser);
        var prizes = [];

        if (this.curRoomState == 1 || this.curRoomState == 2) {
          prizes = curUser.items.slice(0, this.curRoundIndex) || [];
          return prizes;
        }

        if (this.curRoomState == 3) {
          if (curUser.isWinner) {
            prizes = prizes.concat(curUser.items);
            if (this.roomDetail.players.filter((_) => _.isWinner).length <= 1) {
              this.roomDetail.players.forEach((player) => {
                if (player.memberid != memberid)
                  prizes = prizes.concat(
                    player.items.slice(0, this.curAcountingIndex)
                  );
              });
            }

            if (curUser.addBalance > 0) {
              prizes.push({
                id: 0,
                itemPic: coin_icon,
                name: "战斗分红",
                price: curUser.addBalance,
                mSerial: curUser.memberid,
              });
            }
          } else {
            prizes = curUser.items.slice(
              this.curAcountingIndex,
              curUser.items.length
            );
            if (prizes.length == 0)
              prizes.push({
                id: 0,
                itemPic: coin_icon,
                name: "凉凉奖励",
                price: 0.01,
                mSerial: curUser.memberid,
              });
          }
        }

        return prizes;
      };
    },
  },
  watch: {
    curRoomState: {
      async handler(val) {
        // console.log("curRoomState", val);
        if (val == 3) {
          //盒战结束时状态为3,而且赢了才更新
          this.CGReqBattleChallengeDetails(); //获取连胜挑战信息
        }
      },
      deep: true,
      immediate: true,
    },
    isHappyCoin(val, oldVal) {
      if (val == oldVal) return;
      this.initHub();
    },
  },
  async mounted() {
    var sounds = {
      run: new Audio(run_sound),
      win: new Audio(win_sound),
      chat_0: new Audio(main_chat_0),
      chat_1: new Audio(main_chat_1),
      chat_2: new Audio(main_chat_2),
      chat_3: new Audio(main_chat_3),
      emoji_0: new Audio(main_emoji_0),
      emoji_1: new Audio(main_emoji_1),
      count: new Audio(count_sound),
      moving: new Audio(move_sound),
      join: new Audio(join_sound),
    };
    this.sounds = sounds;
    this.quickMessageAudio = new Audio(message);
    this.quickMessageAudio.preload = "auto";
    document.addEventListener("click", this.unlockQuickMessageAudio, true);
    document.addEventListener("touchstart", this.unlockQuickMessageAudio, true);
    await this.initHub();
  },
  beforeDestroy() {
    this.removeQuickMessageAudioUnlockListeners();
    if (this.quickMessageAudio) {
      this.quickMessageAudio.pause();
    }
    this.DestoryListen();
    this.stopAudio();
    clearTimeout(this.animation_timer);
  },
  beforeRouteLeave(to, from, next) {
    if (this.$caseBattleHub.isBattleRoute(to)) {
      next();
      return;
    }

    this.$caseBattleHub.stopHub().then(next).catch(next);
  },
  methods: {
    ...mapMutations(["setSpinShow"]),

    // 触发原有的匹配 AI 按钮绑定的方法（如果是原有按钮，请将它的 @click 绑定改为此方法）
    openAiMatchModal(seatIndex) {
      this.selectedAiId = null;
      this.showQuickMatchDialog = true;
      this.curSelectedSeatIndex = seatIndex;

      this.$caseBattleHub.conn
        .invoke("GCRequestBotList", { RoomId: this.roomDetail.room.id })
        .then((lpMsg) => {
          console.log("GCRequestBotList response:", lpMsg);
          this.availableAiList = lpMsg.data || [];
        }).catch(err => {
          this.setSpinShow(false);
          this.$Message.error("匹配失败，请重试");
        });
    },

    // 1. 自动匹配功能
    async handleAutoMatch() {
      var data = { RoomId: this.roomDetail.room.id, SeatIndex: this.curSelectedSeatIndex };
      this.setSpinShow(true); // 开启加载遮罩

      // 模拟自动匹配：从可用的AI池中随机挑一个ID，或者传 0 / null 让后端算法随机挑
      this.$caseBattleHub.conn
        .invoke("GCRequestFakerJoinRoom", data)
        .then((lpMsg) => {
          this.setSpinShow(false);
          if (lpMsg.success) {
            this.$Message.success("系统智能 AI 已成功加入战场！");
            this.showQuickMatchDialog = false;
          } else {
            this.$Message.error(lpMsg.msg);
          }
        }).catch(err => {
          this.setSpinShow(false);
          this.$Message.error("匹配失败，请重试");
        });
    },

    // 2. 指定 AI 匹配功能
    async handleMatchSpecifiedAi() {
      if (!this.selectedAiId) {
        this.$Message.warning("请先选择一位要指定的 AI 角色");
        return;
      }

      var data = {
        RoomId: this.roomDetail.room.id,
        botId: this.selectedAiId,
        SeatIndex: this.curSelectedSeatIndex
      };
      this.setSpinShow(true);

      this.$caseBattleHub.conn
        .invoke("GCRequestFakerJoinRoom", data)
        .then((lpMsg) => {
          this.setSpinShow(false);
          if (lpMsg.success) {
            this.$Message.success(lpMsg.data || "指定 AI 已成功切入坐席！");
            this.showQuickMatchDialog = false;
          } else {
            this.$Message.error(lpMsg.msg);
          }
        }).catch(err => {
          this.setSpinShow(false);
        });
    },

    Accounting() {
      this.curRoomState = 2;
      setTimeout(() => {
        this.curAcountingIndex++;

        var Rounditems = [];
        this.roomDetail.players.forEach((player) => {
          Rounditems.push(player.items[this.curAcountingIndex - 1]);
        });
        Rounditems.sort((a, b) => b.price - a.price);
        this.curItemMaxPrice = Rounditems[0].price;
        this.curItemMinPrice = Rounditems[Rounditems.length - 1].price;

        if (!this.isMute) {
          this.sounds["count"].currentTime = 0;
          this.sounds["count"].play();
        }

        if (this.curAcountingIndex >= this.roomDetail.room.cases.length) {
          setTimeout(() => {
            this.curAcountingIndex = 0;
            this.curRoomState = 3;
            this.MovingItem();
            // 更新余额
            this.$store.commit("setInfo");
          }, 1000);
          return;
        }

        this.Accounting();
      }, 1000);
    },
    MovingItem() {
      setTimeout(() => {
        this.curAcountingIndex++;

        if (!this.isMute) {
          this.sounds["moving"].currentTime = 0;
          this.sounds["moving"].play();
        }

        if (this.curAcountingIndex >= this.roomDetail.room.cases.length) {
          /*setTimeout(() => {
                      
                      if (this.roomDetail.players.filter(_ => _.isWinner && _.memberid == this.curUserRealId).length > 0 && !this.isReplay) {

                        this.$refs.case_reward_ui.reset();

                        this.roomDetail.players.find(_=>_.memberid == this.curUserRealId).totalItems.forEach(item=>{
                            this.$refs.case_reward_ui.pushItem(
                              item.name , item.mSerial, item.itemPic ,item.rarity , item.price
                            );                 
                        });

                        if(!this.isMute){
                          this.sounds["win"].currentTime = 0;
                          this.sounds["win"].play();
                        }
                        
                        this.$refs.case_reward_ui.show();
                      }

                    }, 1000);*/
          return;
        }

        this.MovingItem();
      }, 500);
    },
    copyRoomUrl() {
      this.$copyText(this.curPageUrl);
      this.$toast.success("复制成功");
    },
    replay() {
      this.curRoomState = 1;
      this.curRoundIndex = 0;
      this.curAcountingIndex = 0;
      this.isReplay = true;
      this.handleShowBoxPkAnim();
    },
    arrowClick(type) {
      var nowmagin = parseInt(this.$refs.round_list.style.marginLeft);
      //console.log(nowmagin);
      nowmagin = nowmagin + (type == 0 ? 86 : -86);
      if (nowmagin > 0) nowmagin = 0;

      if (nowmagin < (this.roomDetail.room.cases.length - 3) * -86)
        nowmagin = (this.roomDetail.room.cases.length - 3) * -86;

      this.$refs.round_list.style.marginLeft = `${nowmagin}px`;
    },
    async initHub() {
      this.DestoryListen();
      await this.$caseBattleHub.initHub(this.isHappyCoin);
      this.$caseBattleHub.conn.on("GCRoomDetailRecv", (data) => {
        console.log("收到推送房间消息" + data.room.id);

        if (this.roomDetail.room.id && this.roomDetail.room.id != data.room.id)
          //不是当前房间的ID不接收
          return;

        if (this.roomDetail.room.roomState > 0)
          //进行中不接收
          return;

        this.roomDetail = data;
        console.log(data)
        console.log("盒战结束房间详情", this.roomDetail);
        this.currentIsWinner = [];
        this.roomDetail.players.forEach((playerItem) => {
          if (playerItem.isWinner) {
            this.currentIsWinner.push(playerItem.memberid);
          }
        });
        if (!this.isMute) {
          this.sounds["join"].currentTime = 0;
          this.sounds["join"].play();
        }

        setTimeout(() => {
          this.SyncRoom(true);
        }, 1000);
      });

      //监听连胜挑战挑战失败
      this.$caseBattleHub.conn.on("GCChallengeFailedRecv", (data) => {
        // console.log("连胜挑战挑战失败", data);
        if (data.roomId) {
          this.isChallengeFailed = true;
          this.isChallengeFailedRoomId = data.roomId;
        } else {
          this.isChallengeFailed = false;
          this.isChallengeFailedRoomId = 0;
        }
      });

      // //监听Emoji
      // this.$caseBattleHub.conn.on("GCRoomEomojiRecv", (data) => {
      //   if (data.roomId != this.roomDetail.room.id) return;

      //   if (data.type == 0) {
      //     //发语音
      //     if (data.actionId >= 0 && data.actionId <= 3) {
      //       this.user_chat_list[data.from].show = true;
      //       this.user_chat_list[data.from].text =
      //         this.emoji_text_list[data.actionId];

      //       if (!this.isMute) {
      //         this.sounds["chat_" + data.actionId].currentTime = 0;
      //         this.sounds["chat_" + data.actionId].play();
      //       }
      //       // setTimeout(() => {
      //       //   this.user_chat_list[data.from].show = false;
      //       // }, 3000);
      //     }
      //   } else {
      //     this.showEmoji(data.actionId, data.from, data.to);
      //   }
      // });

      if (this.$caseBattleHub.conn.state == "Connected") {
        //连接存在
        this.InitRoom(); //初始化房间
        this.CGReqBattleChallengeDetails(); //获取连胜挑战信息
      }

      this.$caseBattleHub.onConnected = () => {
        this.InitRoom(); //初始化房间
        this.CGReqBattleChallengeDetails(); //获取连胜挑战信息
      };

      this.$caseBattleHub.onReconnected = () => {
        this.InitRoom(); //初始化房间
        this.CGReqBattleChallengeDetails(); //获取连胜挑战信息
      };


      this.$chatRoomHub.conn.on("GCRoomQuickMessageRecv", (data) => {
        console.log("收到聊天室消息", data);

        this.roomDetail.players.forEach((playerItem, i) => {
          if (playerItem.memberid == data.memberId) {

            let index = playerItem.seatIndex;

            if (this.user_chat_list[index].curTimeOut) {
              console.log('clear timeout');
              clearTimeout(this.user_chat_list[index].curTimeOut);
            }
            let curTimeOut = setTimeout(() => {
              this.user_chat_list[index].show = false;
            }, 3000);
            this.user_chat_list[index].curTimeOut = curTimeOut;
            this.user_chat_list[index].show = true;
            this.user_chat_list[index].text = data.message;

            this.playQuickMessageAudio(data.audioUrl);
          }
        });
      });

      this.$chatRoomHub.onConnected = () => {
        this.InitChat(); //初始化聊天室
      }
      this.$chatRoomHub.onReconnected = () => {
        this.InitChat(); //初始化聊天室
      }

      if (this.$chatRoomHub.conn.state == "Connected") {
        this.InitChat(); //初始化聊天室
      }

    },
    async showEmoji(type, from, to) {
      var fromEle = this.$refs.battleUserinfo[from];
      // console.log(fromEle);
      var toEle = this.$refs.battleUserinfo[to];

      var div = document.createElement("div");
      var emoji_img = document.createElement("img");
      div.className = "animation_emoji_drop";
      emoji_img.src = type == 0 ? xihongshi_img : chabei_img;
      div.appendChild(emoji_img);

      div.style.transition = "all 1s cubic-bezier(.17,.67,.43,1) .1s";

      fromEle.appendChild(div);

      setTimeout(() => {
        var movepixel =
          toEle.getBoundingClientRect().left -
          fromEle.getBoundingClientRect().left -
          50;
        div.style.marginLeft = movepixel + "px";
      }, 100);

      setTimeout(() => {
        div.style.opacity = 0;
        setTimeout(() => {
          fromEle.removeChild(div);
        }, 1000);
      }, 1200);

      if (!this.isMute) {
        this.sounds["emoji_" + type].currentTime = 0;
        this.sounds["emoji_" + type].play();
      }
    },
    cgChat(from, actid) {
      const msg = this.quick_msg_list[actid];
      if (!msg || this.$chatRoomHub.conn.state != "Connected") return;

      this.$chatRoomHub.conn
        .invoke("GCRequestSendQuickMessage", {
          RoomId: this.roomDetail.room.id,
          Scene: this.roomChatScene,
          MessagePresetId: msg.id,
        })
        .then((res) => {
          if (!res.success) {
            this.$toast.error(res.msg);
          }
        })
        .catch(() => {
          this.$toast.error("发送失败，请稍后再试");
        });
    },
    unlockQuickMessageAudio() {
      if (this.quickMessageAudioUnlocked || this.isMute) return;

      const audio = this.quickMessageAudio || new Audio(message);
      this.quickMessageAudio = audio;
      audio.src = message;
      audio.muted = true;
      audio.currentTime = 0;

      audio
        .play()
        .then(() => {
          audio.pause();
          audio.currentTime = 0;
          audio.muted = false;
          this.quickMessageAudioUnlocked = true;
          this.removeQuickMessageAudioUnlockListeners();
        })
        .catch(() => {
          audio.muted = false;
        });
    },
    removeQuickMessageAudioUnlockListeners() {
      document.removeEventListener("click", this.unlockQuickMessageAudio, true);
      document.removeEventListener("touchstart", this.unlockQuickMessageAudio, true);
    },
    playQuickMessageAudio(audioUrl) {
      if (this.isMute) return;

      const url = audioUrl ? imgfilter(audioUrl) : message;
      const audio = this.quickMessageAudio || new Audio();
      this.quickMessageAudio = audio;
      audio.pause();
      audio.muted = false;
      audio.src = url;
      try {
        audio.currentTime = 0;
      } catch (error) { }
      audio.play().catch(() => { });
    },
    cgEmoji(target, emoji_id) {
      var myIndex = this.roomDetail.players.findIndex(
        (player) => player.memberid == this.curUserRealId
      );

      var data = {
        RoomId: this.roomDetail.room.id,
        Type: 1,
        ActionId: emoji_id,
        From: myIndex,
        To: target,
      };
      this.$caseBattleHub.conn.invoke("GCRequestRoomEmoji", data);
    },
    //取消监听
    DestoryListen() {
      this.$caseBattleHub.onConnected = null;
      this.$caseBattleHub.onReconnected = null;
      this.$caseBattleHub.conn.off("GCRoomDetailRecv");
      this.$caseBattleHub.conn.off("GCChallengeFailedRecv");
      this.$caseBattleHub.conn.off("GCRoomEomojiRecv");

      if (this.$chatRoomHub.conn.state == "Connected" && this.roomDetail.room.id) {
        this.$chatRoomHub.conn.invoke(
          "GCRequestLeaveRoomChat",
          this.roomDetail.room.id,
          this.roomChatScene
        ).catch(() => { });
      }
      this.$chatRoomHub.onConnected = null;
      this.$chatRoomHub.onReconnected = null;
      this.$chatRoomHub.conn.off("GCRoomQuickMessageRecv");
      // console.log("取消监听对战房间详情");
      this.setSpinShow(false);
    },
    InitRoom() {
      console.log("进入这里没");
      this.$caseBattleHub.conn
        .invoke("GCRequestRoomDetail", this.$route.params.id)
        .then((lpMsg) => {
          console.log("初始化获取房间详情==", lpMsg);
          this.roomDetail = lpMsg.data;
          this.currentIsWinner = [];
          this.roomDetail.players.forEach((playerItem) => {
            if (playerItem.isWinner) {
              this.currentIsWinner.push(playerItem.memberid);
            }
          });
          this.SyncRoom();
        });

            //监听更新房间
      this.$caseBattleHub.conn.on("GCRoomDetailRecv", (data) => {
        if (this.roomDetail.room.id !== data.room.id) return;
        console.log("收到推送更新房间消息" + data);
        this.roomDetail.room = data.room;
        this.roomDetail.players = data.players;
      });
    },
    InitChat() {
      console.log("进入这里没2");
      this.$chatRoomHub.conn
        .invoke(
          "GCRequestJoinRoomChat",
          parseInt(this.$route.params.id),
          this.roomChatScene
        )
        .then((cpMsg) => {
          console.log("初始化获取快速聊天室详情==", cpMsg);
        })
        .catch(() => { });
      // 获取快捷消息
      this.GetQuickChatPresetTexts();
    },
    //有资格参加连胜挑战
    async onJoinChallengeHandle() {
      await this.CGReqBattleChallengeDetails();
      this.battle_detail_challenge_des_show = true;
      this.battle_challenge_des_btn_show = true;
    },
    //获取连胜挑战信息GCRequestChallengeInfo接口
    CGReqBattleChallengeDetails() {
      this.$caseBattleHub.conn
        .invoke("GCRequestChallengeInfo")
        .then((cpMsg) => {
          // console.log("获取连胜挑战信息==GCRequestChallengeInfo", cpMsg);
          if (!cpMsg.data.isChallengeEnable) {
            //连胜挑战未开启,接口只返回isChallengeEnable字段，其他字段不返回
            this.battleChallengeDetail.isChallengeEnable =
              cpMsg.data.isChallengeEnable;
            return;
          }
          this.battleChallengeDetail = cpMsg.data;
          let cdkGiftRate = this.battleChallengeDetail.cdkGiftRate.split(",");
          this.cdkGiftRateList = [];
          cdkGiftRate.forEach((item) => {
            let arr = item.split(":");
            if (arr[0] > 1) {
              let obj = {
                num: arr[0],
                rate: arr[1],
              };
              this.cdkGiftRateList.push(obj);
            }
          });
        });
    },
    //加入连胜挑战
    async onGCRequestJoinChallenge() {
      await this.CGReqBattleChallengeDetails();
      if (this.battleChallengeDetail.isCurrentlyInChallenge) {
        this.$toast.error("已参加连胜挑战");
        return;
      }
      if (this.battleChallengeDetail.winningSteakCount < 1) {
        this.$toast.error("暂无资格参加连胜挑战");
        return;
      }
      this.$caseBattleHub.conn
        .invoke("GCRequestJoinChallenge")
        .then((lpMsg) => {
          // console.log("参加连胜挑战lpMsg===", lpMsg);
          if (lpMsg.success) {
            this.$toast.success(lpMsg.data);
            this.battle_detail_challenge_des_show = false;
            this.CGReqBattleChallengeDetails();
          } else {
            this.$toast.error(lpMsg.msg);
          }
        });
    },
    SyncRoom(forcePlayFromStart = false) {
      if (this.roomDetail.room.roomState > 0) {
        if (forcePlayFromStart) {
          clearTimeout(this.animation_timer);
          this.curRoomState = 1;
          this.curRoundIndex = 0;
          this.curAcountingIndex = 0;
          this.showProgress = false;
          this.handleShowBoxPkAnim();
          return;
        }

        //开始或结束
        var totalRoundTime = this.roomDetail.room.cases.length * 10000;
        var timecheck =
          new Date().getTime() -
          new Date(this.roomDetail.server_time.replace(/\-/g, "/")).getTime();
        var ms_over =
          new Date().getTime() -
          new Date(
            this.roomDetail.room.updatedTime.replace(/\-/g, "/")
          ).getTime() -
          timecheck;

        if (ms_over < totalRoundTime && this.roomDetail.room.roomState == 1) {
          this.curRoomState = 1;
          this.curRoundIndex =
            Math.floor(
              (ms_over / totalRoundTime) * this.roomDetail.room.cases.length
            ) - 1; //计算经过了多少回合
          if (this.curRoundIndex < 0) this.curRoundIndex = 0;
          this.curAcountingIndex = 0;
          //开始动画
          this.handleShowBoxPkAnim();
        } else {
          this.curAcountingIndex = this.roomDetail.room.cases.length;
          this.curRoomState = 3;
        }
      } else {
        this.curRoomState = this.roomDetail.room.roomState;
      }
    },
    async handleShowBoxPkAnim() {

      this.showProgress = false;
      await this.$nextTick();

      if (this.curRoundIndex > 0) this.stopAudio();

      var curCaseId = this.roomDetail.room.cases[this.curRoundIndex].id;
      const case_info_response = await api_CaseDetail(curCaseId);
      if (case_info_response.data.code !== 0) {
        return this.$toast.error("初始化对战数据异常,请刷新页面");
      }
      const curCaseInfo = case_info_response.data.data;
      // console.log(curCaseInfo.items);
      this.playAudio();

      this.roomDetail.players.forEach((player, index) => {
        this.$refs[`rollbox_${player.id}`][0].start(
          player.items[this.curRoundIndex].name,
          curCaseInfo.items
        );
      });

      if (this.curRoundIndex < this.roomDetail.room.cases.length) {
        var Rounditems = [];
        this.roomDetail.players.forEach((player) => {
          Rounditems.push(player.items[this.curRoundIndex]);
        });
        Rounditems.sort((a, b) => b.price - a.price);
        this.curItemMaxPrice = Rounditems[0].price;
      }

      //计算回合
      setTimeout(() => {
        this.showProgress = true;
      }, 5500);

      this.animation_timer = setTimeout(() => {
        this.curRoundIndex++;

        if (this.curRoundIndex >= this.roomDetail.room.cases.length) {
          this.curRoundIndex  = this.roomDetail.room.cases.length - 1;
          setTimeout(() => {
            this.Accounting();
          }, 1000);
          return;
        }

        this.handleShowBoxPkAnim();
      }, 10000);
    },

    playAudio() {
      if (!this.isMute) {
        this.sounds["run"].currentTime = 0;
        this.sounds["run"].play();
      }
    },
    stopAudio() {
      this.sounds["run"].pause();
    },
    // 计算对战获取的饰品可兑换的A币
    calculateTotalPrice(products) {
      let tpriceArr = products.filter((item) => {
        return !item.isConvert;
      });
      tpriceArr = tpriceArr.map((item) => {
        return item.price;
      });
      return tpriceArr.reduce((a, b) => a + b, 0) || 0;
    },
    // 兑换成金币
    handleConvertToGold(product, productIndex) {
      let uuids = [];
      if (!product) {
        const noConvertArr = this.roomDetail.players
          .find((_) => _.memberid == this.curUserRealId)
          .totalItems.filter((item, index) => {
            return index !== productIndex;
          });
        uuids = noConvertArr.map((item) => {
          return item.mSerial;
        });
      } else {
        uuids = [product.mSerial];
      }
      const data = { lstMSerial: uuids };
      this.productConvertToGold(data);
    },
    productConvertToGold(data) {
      this.roomDetail.players
        .find((_) => _.memberid == this.curUserRealId)
        .totalItems.forEach((item, index) => {
          if (data.lstMSerial.indexOf(item.mSerial) > -1) {
            item.converting = true;
          }
        });

      api_SellItem(data).then((res) => {
        if (res.data.code == 0) {
          this.$toast.success("兑换成功");
          this.$store.commit("setInfo");
          this.roomDetail.players
            .find((_) => _.memberid == this.curUserRealId)
            .totalItems.forEach((item, index) => {
              if (data.lstMSerial.indexOf(item.mSerial) > -1) {
                item.isConvert = true;
              }
            });
        } else {
          this.$toast.error(res.data.msg);
        }
      });
    },
    // 放入背包
    handleIntoBag() {
      this.showWinDialog = false;
    },
    // 1. 修改打开模态框的方法，接收传入的座位号
    async openJoinRoomModal(seatIndex) {
      if (!this.user.nickname) return this.$store.commit("setloginModal", true);
      if (this.roomDetail.room.roomState != 0) return;

      this.join_room_modal.id = this.roomDetail.room.id;
      this.join_room_modal.hasPassword = this.roomDetail.room.password ? true : false;
      this.join_room_modal.password = "";
      this.join_room_modal.price = this.roomDetail.room.roomPrice;

      // 🟢 记录用户点击的具体座位号 (从0开始的索引)
      this.join_room_modal.seatIndex = seatIndex;

      this.join_room_modal.flag = true;
    },

    // 2. 修改提交加入的方法
    submit_join_room() {
      this.joinRoom(
        this.join_room_modal.id,
        this.join_room_modal.hasPassword ? this.join_room_modal.password : "",
        this.join_room_modal.seatIndex // 🟢 将座位号传给请求方法
      );
      this.join_room_modal.flag = false;
    },

    // 3. 修改核心请求方法
    joinRoom(id, pwd, seatIndex) {
      if (!this.user.nickname) {
        return this.$store.commit("setloginModal", true);
      }

      // 🟢 组装发送给后端的数据，追加 SeatIndex
      var data = {
        roomId: id,
        password: pwd,
        seatIndex: seatIndex // 后端接收的字段名通常为 seatIndex 或 SeatIndex
      };

      this.$caseBattleHub.conn
        .invoke("GCRequestJoinRoom", data)
        .then((lpMsg) => {
          if (lpMsg.success) {
            this.$toast.success(lpMsg.data);
            this.$store.commit("setInfo");
          } else {
            this.$toast.error(lpMsg.msg);
            if (lpMsg.msg.indexOf("余额不足") > -1) {
              this.$store.commit("setPayModal", true);
            }
          }
        });
    },
    async openCaseDetailModal(item) {
      const case_info_response = await api_CaseDetail(item.id);

      if (case_info_response.data.code !== 0) {
        return;
      }

      const respone = case_info_response.data.data;

      let case_info = respone.caseInfo;
      let case_awards = respone.items;
      var currentTotal = 0;
      var totalRate = case_awards
        .map((_) => _.viewRate)
        .reduce((a, b) => a + b, 0);

      case_awards.forEach((item, index) => {
        let weight = Number(item.viewRate);

        let startVal, endVal;

        if (Number.isInteger(item.viewRate) && Number.isInteger(currentTotal)) {
          startVal = currentTotal;
          currentTotal += item.viewRate;
          endVal = currentTotal - 1;
          this.$set(item, 'rollRangeStr', `${startVal}-${endVal}`);
        } else {
          let s = currentTotal;
          let e = currentTotal + weight;
          currentTotal = e;
          this.$set(item, 'rollRangeStr', `${(s + (Number.isInteger(s) ? 0 : 0.01)).toFixed(Number.isInteger(s) ? 0 : 2)}-${e.toFixed(Number.isInteger(e) ? 0 : 2)}`);
        }
        item.viewRate = Math.ceil((weight / totalRate) * 10000000) / 100000;
      });


      this.case_detail_modal.caseInfo = { caseInfo: case_info, items: case_awards };
      this.case_detail_modal.flag = true;
    },
    async InviteBotJoin() {
      var data = { RoomId: this.roomDetail.room.id };
      this.$caseBattleHub.conn
        .invoke("GCRequestFakerJoinRoom", { RoomId: data.RoomId })
        .then((lpMsg) => {
          if (lpMsg.success) {
            this.$Message.success(lpMsg.data);
            //this.$store.commit('setInfo');
          } else {
            this.$Message.error(lpMsg.msg);
          }
        });
    },

    async CancelBattle() {
      var data = { RoomId: this.roomDetail.room.id };
      this.$caseBattleHub.conn
        .invoke("GCRequestCancelRoom", { RoomId: data.RoomId })
        .then((lpMsg) => {
          if (lpMsg.success) {
            this.$Message.success(lpMsg.data);
            this.$router.back();
          } else {
            this.$Message.error(lpMsg.msg);
          }
        });
    },

    async GetQuickChatPresetTexts() {
      if (this.$chatRoomHub.conn.state != "Connected") return;

      const res = await this.$chatRoomHub.conn.invoke(
        "GCRequestQuickMessagePresetList",
        this.roomChatScene
      );
      this.quick_msg_list = (res.data || []).map((item) => ({
        id: item.id,
        text: item.text,
        audioUrl: item.audioUrl,
        sort: item.sort,
        scene: item.scene,
      }));
    },

    // disableOutClick() {
    //   console.log(this.$refs['poptip']);
    //   this.$refs['poptip'][0].handleClose = () => {
    //     console.log('disableOutClick');
    //     return false;
    //   };
    // }
  }
};
